/**
 * MagazinePage.js
 * Parent layout wrapper for all magazine sub-routes under /my-account/magazine/
 * Simply renders the nested route outlet — no visual content of its own.
 */
import React from 'react';
import { Outlet } from 'react-router-dom';

const MagazinePage = () => {
  return <Outlet />;
};

export default MagazinePage;
